<span class="brand-heading-container">
    <div class="brand-heading">
        <a href="https://conversejs.org" target="_blank" rel="noopener">
            <i class="icon-conversejs"></i><span class="brand-name">converse</span>
        </a>
    </div>
</span>
